exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-cv-tsx": () => import("./../../../src/pages/cv.tsx" /* webpackChunkName: "component---src-pages-cv-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-om-mig-tsx": () => import("./../../../src/pages/om-mig.tsx" /* webpackChunkName: "component---src-pages-om-mig-tsx" */),
  "component---src-templates-portfolio-page-tsx": () => import("./../../../src/templates/PortfolioPage.tsx" /* webpackChunkName: "component---src-templates-portfolio-page-tsx" */)
}

